/**
 * client/wrapper type for the Exitpopup widget on page
 */
import BaseWidgetClient from '../core/BaseWidgetClient';
import WidgetTypes from '../core/enums/WidgetTypes';
import TempCache from '../core/enums/TempCache';
import loadJQuery from '../core/hooks/loadJQuery';
import loadJQueryPlugins from '../core/loadJQueryPlugins';
import WidgetStates from '../core/hooks/WidgetStates';
import createNS from '../core/createNs';

export default function RegisterExitPopup() {
    const EP = class extends BaseWidgetClient {
        constructor(options) {
            options.iframeId = 'apexchat_exitpopup2_chatwindow_frame';

            super(
                Object.assign(options, {
                    widget: WidgetTypes.ExitPopup, // containerBg: 'blue'
                    transform: true,
                    elDragnDrop: 'apexchat_ep_dragndrop'
                    // draggables: ['#apexchat-rd-logo-wrapper', '#apexchat-ep .apex-col-1', '.apex-transcript:not(.apex-ep-text)']
                })
            );
            const me = this;

            TempCache.EP_INITIAL_LOAD_TIME = (options.exitPopupDelaySeconds || 3) * 1000;
            ApexChat.TempSize = {};
            ApexChat.TempSize.iframeWidth = this.options.width = '656px';
            ApexChat.TempSize.iframeHeight = this.options.height = '552px';
            this.subscribe(WidgetTypes.ExitPopup + WidgetStates.ShownMaximized, () => {
                if (!me.isMobile()) {
                    // me.handleZooming();
                }
            });

            this.mouseMovingUp = false;
            this.scrollingTop = false;
            // TODO: We can merge the following with _resizeIframe in the above//original object
            this.subscribe(`${WidgetTypes.ExitPopup}_resize_iframe`, (args) => {
                me.$(me.$container).show();
                const iframeId = document.getElementById(me.iframeId);
                if (args.state == WidgetStates.ShownMaximized) {
                    // JIRA_4343 - EP's bottom cuts off if company name is in multiple lines
                    const measureCompanyLongName =
                        iframeId.contentDocument.querySelector('.apex-title-bar').offsetHeight;
                    iframeId.style.height = `${parseInt(args.height) + 165 + measureCompanyLongName
                        }px`;

                    iframeId.style.width = args.width;
                } else if (args.state == WidgetStates.ShownMinimized) {
                    me.$(me.$container).css({
                        'z-index': '9999999',
                        position: 'fixed',
                        bottom: '0',
                        transform: '',
                        top: '',
                        left: ''
                    });
                    iframeId.style.height = args.height;
                    iframeId.style.width = args.width;
                    iframeId.style.display = args.display;
                }
            });

            this.subscribe(WidgetTypes.ExitPopup + WidgetStates.Hidden, (args) => {
                // CHAT-7943 - EP QT msgs to DOM were not rendering due to this AllHisotryMessage variable was filled with old chatlog
                // and when moving to DOM, it was fetching the history again and was not working due to duplication.
                ApexChat.allHistoryMessages = []; // assign empty array
                document.getElementById(me.parentDivId).style.display = 'none';
            });
            this.subscribe(WidgetTypes.ExitPopup + WidgetStates.Closed, (args) => {
                ApexChat.allHistoryMessages = []; // assign empty array
                document.getElementById(me.parentDivId).style.display = 'none';
            });
            this.ready();
        }

        ready() {
            super.ready();
            // this.notifyAll([WidgetStates.Closed, WidgetStates.ShownMinimized, WidgetStates.ShownMaximized]);
            this.create();
        }

        create() {
            super.create();
            const me = this;
            let iframeADAZoomingClass = 'apexchat_std_ep_zooming_iframe';
            me.elDragnDropCss =
                'width: 245px; height: 54px; top: 12px; left: 270px; cursor:grab;display: none'; // CHAT-5421 {V3] RD EP language drop down is being cut off.
            ApexChat.TempSize.iframeWidth = this.options.width = '766px';
            ApexChat.TempSize.iframeHeight = this.options.height = '580px'; // CHAT-5421 {V3] RD EP language drop down is being cut off.
            iframeADAZoomingClass = 'apexchat_rd_ep_zooming_iframe';
            me.$container.innerHTML = `<iframe  tabindex="0"  class="${me.widget}_frame ${me.widget}_iframe_custom ${iframeADAZoomingClass}"  id="${me.iframeId}"  style=" width: ${this.options.width}; height: ${this.options.height}; border: none;overflow-x:hidden; overflow-y:hidden;display: none;" marginheight="0" marginwidth="0" frameBorder="0" scrolling="no" horizontalscrolling="no" verticalscrolling="no"  allowtransparency="true" title="Chat Exit Popup"></iframe><div id="${me.elDragnDrop}" style="width: 45%; height: 40px;  position: absolute; right: 115px; top: 20px;cursor:move;${me.elDragnDropCss}"></div>`;
            document.body.appendChild(me.$container);
            this.show();
            this.detectDocumentClosing();
        }

        show() {
            super.show();
        }

        maximize(e) {
            const me = this;
            const epIsOpen = this.state.getStateValue(WidgetStates.ShownMaximized);
            const epClosedOrHiddenForcefully =
                this.state.getStateValue(WidgetStates.Closed) ||
                this.state.getStateValue(WidgetStates.Hidden);
            const epIsMinimized = this.state.getStateValue(WidgetStates.ShownMinimized);
            if (epIsOpen || epClosedOrHiddenForcefully || epIsMinimized) {
                // ZEE: only show 1 time; this needs to be improved as per existing scenarios handled currently
                return; // add further conditions/scenarios
            }
            const isChatIdAlive = this.isChatInProgress();
            const domMax = this.state.getStateValue(
                WidgetStates.ShownMaximized,
                WidgetTypes.DOM
            );
            const domMin = this.state.getStateValue(
                WidgetStates.ShownMinimized,
                WidgetTypes.DOM
            );
            const domClosed = this.state.getStateValue(
                WidgetStates.Closed,
                WidgetTypes.DOM
            );
            if (isChatIdAlive && domMax && (!domClosed || !domMin)) {
                // Rule: chatId exists AND dom is in use
                return;
            }
            me.state.changeState({ toState: WidgetStates.MouseExit });
            me.mouseMovingUp = false;
        }

        detectDocumentClosing() {
            const showMaximizeOrNot = (e, mouseMovingUp) => {
                function scrollTop(el, value) {
                    var win;
                    if (el.window === el) {
                        win = el;
                    } else if (el.nodeType === 9) {
                        win = el.defaultView;
                    }

                    if (value === undefined) {
                        return win ? win.pageYOffset : el.scrollTop;
                    }

                    if (win) {
                        win.scrollTo(win.pageXOffset, value);
                    } else {
                        el.scrollTop = value;
                    }
                }
                //const checkScroll = document.hasFocus(); // also make sure if mouse is leaving document from top not elsewhere
                var checkScroll = (e.pageY - scrollTop(window) <= 1);
                const preChatStarted = ApexChat.storageAPI.Get('livechat_prechat_started');
                if (
                    mouseMovingUp &&
                    checkScroll &&
                    !TempCache.WINDOWED_CHAT_STARTED &&
                    (!preChatStarted || preChatStarted == 'false')
                ) {
                    // so mouse is moving up and it left document? Show EP.
                    me.maximize(); // make sure EP is not already on screen/open
                }
                mouseMovingUp = false;
            }
            const me = this;
            TempCache.EP_SetTimeOut = setTimeout(() => {
                let oldY = 0;
                let mouseMovingUp = false;
                document.addEventListener('mousemove', (e) => {
                    mouseMovingUp = e.pageY <= oldY; // cuz  when e.pageY increases then it means mouse is moving down in which case we should not show EP
                    oldY = e.pageY;
                });
                document.addEventListener('mouseout', async (e) => {
                    if (!me.ExitChatWindow) {
                        await loadJQuery();
                        loadJQueryPlugins(ApexChat.ApexChatJquery);
                        import(/* webpackChunkName: "exitChatWindow" */ '../exitpopup/ExitChatWindow').then(
                            (module) => {
                                me.ExitChatWindow = module.default;
                                const chat = new me.ExitChatWindow(this.options);

                                showMaximizeOrNot(e, mouseMovingUp);
                            }
                        );
                    } else {
                        showMaximizeOrNot(e, mouseMovingUp);
                    }

                });
            }, TempCache.EP_INITIAL_LOAD_TIME); // JIRA_2986 - Exit Pop-up - do not allow to appear at first after a certain set time on back end
        }

        /**
         * On zoom in/out, we adjust EP size to remain visible in the browser viewport based on device pixel ratio info obtained from window object
         * We call this on EP maximize
         * */
        handleZooming() {
            const me = this;
            me.$(window).resize(() => {
                const iframe = document.getElementById(me.iframeId);
                let frameDoc = iframe.document;
                if (iframe.contentWindow) {
                    frameDoc = iframe.contentWindow.document;
                }
                if (window.devicePixelRatio >= 1.12 && window.devicePixelRatio < 1.5) {
                    iframe.style.transform = 'scale(0.88)';
                } else if (window.devicePixelRatio >= 1.5 && window.devicePixelRatio < 1.75) {
                    iframe.style.transform = 'scale(0.732)';
                } else if (window.devicePixelRatio >= 1.75 && window.devicePixelRatio < 2.0) {
                    iframe.style.transform = 'scale(0.63)';
                } else if (window.devicePixelRatio >= 2.0 && window.devicePixelRatio < 2.5) {
                    iframe.style.transform = 'scale(0.55)';
                } else if (window.devicePixelRatio >= 2.5 && window.devicePixelRatio < 3.0) {
                    iframe.style.transform = 'scale(0.44)';
                } else if (window.devicePixelRatio >= 3.0 && window.devicePixelRatio < 4.0) {
                    iframe.style.transform = 'scale(0.365)';
                } else if (window.devicePixelRatio >= 4.0 && window.devicePixelRatio < 4.5) {
                    iframe.style.transform = 'scale(0.275)';
                } else if (window.devicePixelRatio >= 4.5 && window.devicePixelRatio <= 5.0) {
                    iframe.style.transform = 'scale(0.22)';
                } else {
                    iframe.style.transform = 'scale(1)';
                }
            });
        }
    };
    const fqName = `${WidgetTypes.ExitPopup}_client`;
    // Export to window
    createNS(fqName, EP);
}
